import React from 'react';
import { Button } from '@roo/roo';
import Table from '@roo/roo/Table';
import Tabs from '@roo/roo/Tabs';
import { getCookie } from '@utiljs/cookie';
import { connect } from 'react-redux';
import Empty from '@/components/Empty/index';
import request from '@/utils/request';
import utils from '@/utils/utils';

import './index.scss';

const { Pane: TabPane } = Tabs;

interface IState {
    tableList: any;
    activeType: string;
    tableLoading: boolean;
}

interface IProps {
    setEditData: any;
    history: any;
}

class FreightList extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        const urlObj: any = utils.urlParse();

        this.state = {
            tableList: [],
            tableLoading: true,
            activeType: urlObj.type || '1',
        };
    }

    async componentDidMount() {
        const { state } = this;
        this.getTableList(state.activeType);
    }

    // 请求数据，type=1表示运费模板，2表示发货模板
    getTableList = async (type: string = '1') => {
        this.setState({
            tableLoading: true,
        });
        const url = type === '1' ? '/api/carriageTemplates/list' : '/api/dispatchTemplates/list';
        const listRes = await request.get(url, {
            providerId: getCookie('serviceProviderID'),
        });
        if (listRes.code === 0) {
            this.setState({
                tableList: listRes.data,
                tableLoading: false,
            });
        }
    };

    handleAddFreightClick = () => {
        const { props } = this;
        this.setState({
            tableList: [],
            tableLoading: true,
        });
        props.history.push('/freight/addFreight');
    };

    handleAddGoodsClick = () => {
        const { props } = this;
        this.setState({
            tableList: [],
            tableLoading: true,
        });
        props.history.push('/freight/addSendGoods');
    };

    handleEditTemplate = (record: any) => {
        const { props } = this;
        props.setEditData(record);
        this.setState({
            tableList: [],
            tableLoading: true,
        });
        props.history.push(`/freight/addFreight?templateId=${record.templateId}`);
    };

    handleEditGoods = (record: any) => {
        const { props } = this;
        props.setEditData(record);
        this.setState({
            tableList: [],
            tableLoading: true,
        });
        props.history.push(`/freight/addSendGoods?templateId=${record.dispatchTemplateInfoId}`);
    };

    render() {
        const { state } = this;
        const columns: any = [
            { prop: 'templateName', label: '模板名称' },
            {
                prop: 'billType',
                label: '计费方式',
                render: (text: any) => {
                    const bill = text === 1 ? '按件计费' : '按重量计费';
                    return bill;
                },
            },
            {
                prop: '',
                label: '操作',
                render: (text: any, record: any) => (
                    <a
                        href="javascript: void(0);"
                        onClick={() => {
                            this.handleEditTemplate(record);
                        }}
                    >
                        编辑
                    </a>
                ),
            },
        ];
        const columns1: any = [
            {
                prop: 'provinceName',
                label: '发货地区',
                render: (text: any, record: any) => {
                    const name = `${record.provinceName}-${record.cityName}-${record.districtName}`;
                    return name;
                },
            },
            {
                prop: 'dispatchStartTime',
                label: '发货时间',
                render: (text: any) => {
                    const target = text < 24 ? `${text}小时内` : `${text / 24}天内`;
                    return target;
                },
            },
            {
                prop: 'dispatchLogisticsCompanyInfo',
                label: '合作物流公司',
                render: (text: any) => {
                    if (!text) {
                        return '';
                    }
                    const arr = text.map((item: any) => item.logisticsCompanyName);
                    return arr.join('、');
                },
            },
            {
                prop: '',
                label: '操作',
                render: (text: any, record: any) => (
                    <div>
                        <Button
                            type="text"
                            onClick={() => {
                                this.handleEditGoods(record);
                            }}
                        >
                            编辑
                        </Button>
                    </div>
                ),
            },
        ];
        return (
            <div className="page freight-list">
                <Tabs
                    type="line"
                    value={state.activeType}
                    onTabClick={tab => {
                        this.setState({
                            activeType: tab,
                            tableList: [],
                        });
                        this.getTableList(tab);
                    }}
                >
                    <TabPane label="运费模板" name="1">
                        <div className="title20" style={{ marginTop: 30 }}>
                            运费模板
                        </div>
                        {state.tableList.length ? (
                            <div>
                                <Table
                                    rowKey="id"
                                    border
                                    columns={columns}
                                    loading={state.tableLoading}
                                    data={state.tableList}
                                    style={{ width: 700 }}
                                />
                            </div>
                        ) : (
                            <div>
                                {!state.tableLoading ? <Empty tips="您还没有设置运费模板" /> : ''}
                            </div>
                        )}
                        <div
                            className={`button-style ${
                                !state.tableList.length && !state.tableLoading ? 'empty-button' : ''
                            }`}
                        >
                            <Button onClick={this.handleAddFreightClick}>新建运费模板</Button>
                        </div>
                    </TabPane>
                    <TabPane label="发货设置" name="2">
                        <div className="title20" style={{ marginTop: 30 }}>
                            发货设置
                        </div>
                        {state.tableList.length ? (
                            <div>
                                <Table
                                    rowKey="id"
                                    border
                                    loading={state.tableLoading}
                                    columns={columns1}
                                    data={state.tableList}
                                    style={{ width: 900 }}
                                />
                            </div>
                        ) : (
                            <div>
                                {!state.tableLoading ? <Empty tips="您还没有设置发货地区" /> : ''}
                            </div>
                        )}
                        <div
                            className={`button-style ${
                                !state.tableList.length && !state.tableLoading ? 'empty-button' : ''
                            }`}
                        >
                            <Button onClick={this.handleAddGoodsClick}>添加发货地区</Button>
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        setEditData: (editData: any) => {
            const type = 'freight/update';
            return dispatch({
                type,
                payload: {
                    editData,
                },
            });
        },
    };
}

export default connect(null, mapDispatchToProps)(FreightList);
